"use client";
import React, { useEffect, useRef } from "react";
import skills from "../data/skills.json";
import { useTranslation } from "react-i18next";

function Skills() {
  const sectionRef = useRef(null);
  // const [skills, setSkills] = useState<skillType[]>([]);
  useEffect(() => {
    if (window.location.hash === "#skills") {
      sectionRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, []);
  const { t } = useTranslation("translation");
  return (
    <div className="flex flex-col">
      <h1 className="text-2xl font-bold mb-2 text-[var(--color-main)]">{t("header.skills")} </h1>
      <div
        ref={sectionRef}
        id="skills"
        className="flex flex-wrap gap-9 justify-center"
      >
        {skills.map((skill) => (
          // <AnimatedItem key={skill.id}>
          <li key={skill.id} className="list-none  relative  w-20 h-20">
            <img src={skill.img} alt={skill.name} fill loading="lazy" />
          </li>
          // </AnimatedItem>
        ))}
      </div>
    </div>
  );
}

export default Skills;
